let en = {
    home: {
      "hello": "Hello"
    },
    footer: {
      "address": "Address"
    }
  };
  
  export default en;